import script from "./FilterSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSelector.vue?vue&type=script&setup=true&lang=js"

import "./FilterSelector.vue?vue&type=style&index=0&id=5bb9f068&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb9f068"]])

export default __exports__